import { alpha, keyframes, StepConnector, stepConnectorClasses, styled } from '@mui/material'

const activePulse = keyframes({
  '0%': {
    boxShadow: '0 0 0 0 var(--stepper-pulse-start)'
  },
  '70%': {
    boxShadow: '0 0 0 8px var(--stepper-pulse-end)'
  },
  '100%': {
    boxShadow: '0 0 0 0 var(--stepper-pulse-end)'
  }
})

export const LineConnector = styled(StepConnector)<{
  orientation: 'horizontal' | 'vertical'
  widthLine?: number
  heightLine?: number
  marginLeft?: number
  colorLine?: string
  isTiny?: boolean
}>(({ orientation, heightLine, marginLeft, colorLine, isTiny }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: orientation === 'horizontal' ? (isTiny ? 8 : 12) : undefined,
    left: orientation === 'horizontal' ? `calc(-50% + ${isTiny ? '8px' : '30px'})` : undefined,
    right: orientation === 'horizontal' ? `calc(50% + ${isTiny ? '8px' : '30px'})` : undefined
  },
  ...(orientation === 'horizontal' && {
    marginLeft: 5,
    marginRight: 5
  }),
  [`& .${stepConnectorClasses.line}`]: {
    height: orientation === 'horizontal' ? 2 : heightLine,
    width: orientation === 'horizontal' ? '100%' : 2,
    marginLeft: orientation === 'horizontal' ? 0 : marginLeft,
    marginTop: 0,
    border: `1px solid ${colorLine}`,
    backgroundColor: colorLine,
    borderRadius: 1
  }
}))

export const StepIconComponentRoot = styled('div')<{
  state: { completed?: boolean; active?: boolean }
  sizeBox?: string
  activeSizeBox?: string
  fontSizeIndex?: string
  colorComplete?: string
  colorActive?: string
  textActive?: string
  colorIdle?: string
  textIdle?: string
}>(({ state, sizeBox, activeSizeBox, fontSizeIndex, colorComplete, colorActive, colorIdle, textActive, textIdle }) => ({
  '--stepper-pulse-start': alpha(colorActive || colorIdle || 'currentColor', 0.22),
  '--stepper-pulse-end': alpha(colorActive || colorIdle || 'currentColor', 0),
  zIndex: 1,
  width: sizeBox,
  height: sizeBox,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: fontSizeIndex,
  fontWeight: 600,
  borderRadius: '50%',
  border: `1.5px solid ${colorIdle}`,
  backgroundColor: colorIdle,
  color: textIdle,
  boxSizing: 'border-box',

  ...(state.active && {
    width: activeSizeBox || sizeBox,
    height: activeSizeBox || sizeBox,
    borderColor: colorActive,
    backgroundColor: colorActive,
    color: textActive,
    animation: `${activePulse} 1.8s ease-out infinite`
  }),

  ...(state.completed && {
    borderColor: colorComplete,
    backgroundColor: colorComplete,
    color: textActive
  })
}))
